(function () {
  'use strict';

  function getPointerPercent(media, event) {
    var rect = media.getBoundingClientRect();
    if (!rect.width) return 50;

    var clientX = event.touches && event.touches.length
      ? event.touches[0].clientX
      : event.clientX;

    return ((clientX - rect.left) / rect.width) * 100;
  }

  function initCompare(root) {
    if (!root || root.dataset.pdpCompareInit === 'true') return;
    root.dataset.pdpCompareInit = 'true';

    var media = root.querySelector('[data-compare-media]');
    var beforeWrap = root.querySelector('[data-compare-before]');
    var beforeImg = beforeWrap && beforeWrap.querySelector('img');
    var handle = root.querySelector('[data-compare-handle]');
    var startPos = parseFloat(root.getAttribute('data-compare-start')) || 50;

    if (!media || !beforeWrap || !beforeImg || !handle) return;

    var isDragging = false;

    function syncBeforeImageSize() {
      var rect = media.getBoundingClientRect();
      beforeImg.style.width = rect.width + 'px';
      beforeImg.style.height = rect.height + 'px';
    }

    function setPosition(percent) {
      var position = Math.max(0, Math.min(100, percent));
      beforeWrap.style.width = position + '%';
      handle.style.left = position + '%';
      handle.setAttribute('aria-valuenow', String(Math.round(position)));
    }

    function startDrag(event) {
      isDragging = true;
      if (media.setPointerCapture && event.pointerId != null) {
        media.setPointerCapture(event.pointerId);
      }
      setPosition(getPointerPercent(media, event));
      event.preventDefault();
    }

    function moveDrag(event) {
      if (!isDragging) return;
      setPosition(getPointerPercent(media, event));
      event.preventDefault();
    }

    function endDrag(event) {
      if (!isDragging) return;
      isDragging = false;
      if (media.releasePointerCapture && event.pointerId != null) {
        try {
          media.releasePointerCapture(event.pointerId);
        } catch (error) {
          /* noop */
        }
      }
    }

    media.addEventListener('pointerdown', startDrag);
    media.addEventListener('pointermove', moveDrag);
    media.addEventListener('pointerup', endDrag);
    media.addEventListener('pointercancel', endDrag);

    media.addEventListener('touchstart', startDrag, { passive: false });
    media.addEventListener('touchmove', moveDrag, { passive: false });
    media.addEventListener('touchend', endDrag);
    media.addEventListener('touchcancel', endDrag);

    handle.addEventListener('keydown', function (event) {
      var step = event.shiftKey ? 10 : 2;
      var current = parseFloat(handle.getAttribute('aria-valuenow')) || 50;

      if (event.key === 'ArrowLeft' || event.key === 'ArrowDown') {
        setPosition(current - step);
        event.preventDefault();
      }

      if (event.key === 'ArrowRight' || event.key === 'ArrowUp') {
        setPosition(current + step);
        event.preventDefault();
      }
    });

    if (window.ResizeObserver) {
      new ResizeObserver(syncBeforeImageSize).observe(media);
    } else {
      window.addEventListener('resize', syncBeforeImageSize);
    }

    if (beforeImg.complete) {
      syncBeforeImageSize();
    } else {
      beforeImg.addEventListener('load', syncBeforeImageSize);
    }

    syncBeforeImageSize();
    setPosition(startPos);
  }

  function initAll(scope) {
    var context = scope || document;
    context.querySelectorAll('[data-pdp-compare]').forEach(initCompare);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
